import { render, staticRenderFns } from "./textTitle5.vue?vue&type=template&id=336ce643&scoped=true"
import script from "./textTitle5.vue?vue&type=script&lang=js"
export * from "./textTitle5.vue?vue&type=script&lang=js"
import style0 from "./textTitle5.vue?vue&type=style&index=0&id=336ce643&prod&scoped=true&lang=scss"
import style1 from "./textTitle5.vue?vue&type=style&index=1&id=336ce643&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ce643",
  null
  
)

export default component.exports